module.exports = __webpack_public_path__ + "static/media/doc2.bde66512.jpg";